import { render, staticRenderFns } from "./NeuroStart.vue?vue&type=template&id=b8be5468&scoped=true&lang=pug&"
import script from "./NeuroStart.vue?vue&type=script&lang=js&"
export * from "./NeuroStart.vue?vue&type=script&lang=js&"
import style0 from "./NeuroStart.vue?vue&type=style&index=0&id=b8be5468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8be5468",
  null
  
)

export default component.exports